// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1Spo7","colMin":"styles_colMin__vQJMn","colCheckbox":"styles_colCheckbox__7YlpL"};